import api from "../api";

/**
 * 保存共通方法
 * @param {*} params
 * @param {*} url
 */
const save = (params, url) =>
  api.post({
    service: "USER_AUTH_SERVICEINTERFACE",
    url: url,
    urlItem: "1/",
    headers: { "Content-Type": "application/json" },
    data: params,
    loading: true,
    token: true
  });

const upyunUpload = params =>
  api.post({
    service: "USER_AUTH_SERVICEINTERFACE",
    url: "yun/upyunUploadFile",
    urlItem: "1/",
    data: {
      primaryFile:
        params.time +
        params.fileName.substring(params.fileName.lastIndexOf(".")),
      recordType: params.recordType,
      dataTypeId: params.dataTypeId,
      userId: "123456789"
    },
    headers: { "Content-Type": "application/json" },
    loading: false,
    token: false
  });
//远程搜索游玩地
const remote = (params, url) =>
  api.post({
    service: "USER_AUTH_SERVICEINTERFACE",
    url: "info/queryInfo",
    data: params,
    loading: false,
    token: true
  });

//上传文件（恒全）
const uploadFile = (params, url) =>
  api.post({
    service: "UPLOAD_IMG_SERVICEINTERFACE",
    url: "storage/obtainUploadAuth",
    data: params,
    loading: false,
    token: true
  });

/**
 * 图片url转id
 * @param {*} params
 * @param {*} url
 */
const urlToId = (params, url) =>
  api.post({
    service: "USER_AUTH_SERVICEINTERFACE",
    url: url,
    urlItem: "1/",
    headers: {
      "Content-Type": "application/json"
    },
    data: params,
    loading: false,
    token: false
  });

export default {
  save,
  upyunUpload,
  remote,
  urlToId,
  uploadFile
};
